// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Webapi__Fetch = require("rescript-webapi/src/Webapi/Webapi__Fetch.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var TimeZones$ReactHooksTemplate = require("./timeZones.res.js");
var Organization$ReactHooksTemplate = require("../settings/organization.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var CurrentOrganization$ReactHooksTemplate = require("../CurrentOrganization.res.js");

function OrganisationProfile(props) {
  var match = React.useContext(CurrentOrganization$ReactHooksTemplate.authContext);
  var setOrganizationProfile = match[1];
  var organizationProfile = match[0];
  var match$1 = React.useState(function (param) {
        return {
                logo_edited: false,
                name_edited: false,
                saving: false,
                showUploadInputField: false,
                logoUrl: undefined,
                logoFile: undefined,
                notification: undefined,
                logoError: undefined
              };
      });
  var setState = match$1[1];
  var state = match$1[0];
  var handleLogoChange = function ($$event) {
    var target = $$event.target;
    var logoFile = Caml_array.get(target.files, 0);
    target.value = "";
    var fileType = logoFile.type;
    var fileSize = logoFile.size;
    var validFileType = fileType === "image/png" || fileType === "image/jpg" || fileType === "image/jpeg";
    if (!validFileType) {
      return Curry._1(setState, (function (param) {
                    return {
                            logo_edited: state.logo_edited,
                            name_edited: state.name_edited,
                            saving: state.saving,
                            showUploadInputField: state.showUploadInputField,
                            logoUrl: state.logoUrl,
                            logoFile: state.logoFile,
                            notification: {
                              TAG: "Failure",
                              _0: "Invalid file type. Please upload a PNG, JPG, or JPEG image"
                            },
                            logoError: "Only PNG, JPG, and JPEG images are allowed"
                          };
                  }));
    }
    if (fileSize > 307200) {
      return Curry._1(setState, (function (param) {
                    return {
                            logo_edited: state.logo_edited,
                            name_edited: state.name_edited,
                            saving: state.saving,
                            showUploadInputField: state.showUploadInputField,
                            logoUrl: state.logoUrl,
                            logoFile: state.logoFile,
                            notification: {
                              TAG: "Failure",
                              _0: "File size exceeds 300KB limit. Please choose a smaller image"
                            },
                            logoError: "File size must be less than 300KB"
                          };
                  }));
    }
    var logoUrl = window.URL.createObjectURL(logoFile);
    Curry._1(setState, (function (param) {
            return {
                    logo_edited: true,
                    name_edited: state.name_edited,
                    saving: state.saving,
                    showUploadInputField: false,
                    logoUrl: logoUrl,
                    logoFile: Caml_option.some(logoFile),
                    notification: undefined,
                    logoError: undefined
                  };
          }));
  };
  var showUploadInputField = function ($$event) {
    $$event.preventDefault();
    Curry._1(setState, (function (state) {
            return {
                    logo_edited: true,
                    name_edited: state.name_edited,
                    saving: state.saving,
                    showUploadInputField: true,
                    logoUrl: state.logoUrl,
                    logoFile: state.logoFile,
                    notification: state.notification,
                    logoError: state.logoError
                  };
          }));
  };
  var revertLogoChanges = function ($$event) {
    $$event.preventDefault();
    Curry._1(setState, (function (state) {
            return {
                    logo_edited: false,
                    name_edited: state.name_edited,
                    saving: state.saving,
                    showUploadInputField: false,
                    logoUrl: Organization$ReactHooksTemplate.logo(organizationProfile),
                    logoFile: undefined,
                    notification: state.notification,
                    logoError: undefined
                  };
          }));
  };
  var saveClientDetails = function ($$event) {
    $$event.preventDefault();
    Curry._1(setState, (function (state) {
            return {
                    logo_edited: state.logo_edited,
                    name_edited: state.name_edited,
                    saving: true,
                    showUploadInputField: state.showUploadInputField,
                    logoUrl: state.logoUrl,
                    logoFile: state.logoFile,
                    notification: undefined,
                    logoError: state.logoError
                  };
          }));
    var formData = new FormData();
    var organizationName = Organization$ReactHooksTemplate.name(organizationProfile);
    var timeZone = Organization$ReactHooksTemplate.timeZone(organizationProfile);
    if (organizationName === "") {
      return Curry._1(setState, (function (state) {
                    return {
                            logo_edited: state.logo_edited,
                            name_edited: state.name_edited,
                            saving: false,
                            showUploadInputField: state.showUploadInputField,
                            logoUrl: state.logoUrl,
                            logoFile: state.logoFile,
                            notification: {
                              TAG: "Failure",
                              _0: "Organization name cannot be empty"
                            },
                            logoError: state.logoError
                          };
                  }));
    }
    var file = state.logoFile;
    if (file !== undefined) {
      formData.append("organization[logo]", Caml_option.valFromOption(file), undefined);
      formData.append("organization[name]", organizationName);
      formData.append("organization[time_zone]", timeZone);
    } else {
      formData.append("organization[name]", organizationName);
      formData.append("organization[time_zone]", timeZone);
    }
    Js_promise.$$catch((function (error) {
            console.log(error);
            Curry._1(setState, (function (state) {
                    return {
                            logo_edited: state.logo_edited,
                            name_edited: state.name_edited,
                            saving: false,
                            showUploadInputField: state.showUploadInputField,
                            logoUrl: state.logoUrl,
                            logoFile: state.logoFile,
                            notification: {
                              TAG: "Failure",
                              _0: "Network error. Please check your connection"
                            },
                            logoError: state.logoError
                          };
                  }));
            return Promise.resolve();
          }), Js_promise.then_((function (response) {
                var status = Json_decode.field("status", (function (param) {
                        return Json_decode.withDefault("failure", Json_decode.string, param);
                      }), response);
                if (status === "success") {
                  var organization = Json_decode.field("organization", Organization$ReactHooksTemplate.decode, response);
                  Curry._1(setOrganizationProfile, organization);
                  Curry._1(setState, (function (state) {
                          return {
                                  logo_edited: false,
                                  name_edited: false,
                                  saving: false,
                                  showUploadInputField: false,
                                  logoUrl: undefined,
                                  logoFile: undefined,
                                  notification: {
                                    TAG: "Success",
                                    _0: "Organization profile updated successfully"
                                  },
                                  logoError: state.logoError
                                };
                        }));
                } else {
                  Curry._1(setState, (function (state) {
                          return {
                                  logo_edited: state.logo_edited,
                                  name_edited: state.name_edited,
                                  saving: false,
                                  showUploadInputField: state.showUploadInputField,
                                  logoUrl: state.logoUrl,
                                  logoFile: state.logoFile,
                                  notification: {
                                    TAG: "Failure",
                                    _0: "Failed to update profile. Please try again"
                                  },
                                  logoError: state.logoError
                                };
                        }));
                }
                return Promise.resolve();
              }), Js_promise.then_((function (response) {
                    return response.json();
                  }), fetch("/api/v1/organizations/update", Webapi__Fetch.RequestInit.make("Post", [
                          [
                            "X-CSRF-TOKEN",
                            Utils$ReactHooksTemplate.csrfToken
                          ],
                          [
                            "Accept",
                            "*"
                          ]
                        ], Caml_option.some(formData), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)))));
  };
  var enableUpdate = Organization$ReactHooksTemplate.name(organizationProfile) === "" ? true : !state.logo_edited && !state.name_edited;
  var handleChange = function ($$event) {
    var timeZone = $$event.target.value;
    Curry._1(setOrganizationProfile, Organization$ReactHooksTemplate.setTImeZone(organizationProfile, timeZone));
    Curry._1(setState, (function (state) {
            return {
                    logo_edited: state.logo_edited,
                    name_edited: true,
                    saving: state.saving,
                    showUploadInputField: state.showUploadInputField,
                    logoUrl: state.logoUrl,
                    logoFile: state.logoFile,
                    notification: state.notification,
                    logoError: state.logoError
                  };
          }));
  };
  var hasChanges = state.logo_edited || state.name_edited;
  var alertType = state.notification;
  var tmp;
  if (state.showUploadInputField) {
    var error = state.logoError;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("input", {
                          className: "w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4\n                                file:rounded-lg file:border-0 file:text-sm file:font-semibold\n                                file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100\n                                cursor-pointer",
                          accept: ".png,.jpg,.jpeg",
                          type: "file",
                          onChange: handleLogoChange
                        }),
                    JsxRuntime.jsx("p", {
                          children: "PNG, JPG or JPEG (MAX. 300KB)",
                          className: "text-xs text-gray-500 mt-2"
                        })
                  ],
                  className: "border-2 border-dashed border-gray-300 rounded-lg p-6 bg-gray-50 hover:border-blue-400 transition-colors"
                }),
            error !== undefined ? JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("span", {
                            children: "❌",
                            className: "text-red-600"
                          }),
                      JsxRuntime.jsx("p", {
                            children: error,
                            className: "text-sm text-red-700"
                          })
                    ],
                    className: "p-3 bg-red-50 border border-red-200 rounded-lg flex items-start space-x-2"
                  }) : null,
            JsxRuntime.jsx("button", {
                  children: "Cancel",
                  className: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors",
                  onClick: revertLogoChanges
                })
          ],
          className: "space-y-4"
        });
  } else {
    var match$2 = state.logoUrl;
    var match$3 = Organization$ReactHooksTemplate.logo(organizationProfile);
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                        children: match$2 !== undefined ? JsxRuntime.jsx("img", {
                                className: "w-full h-full object-contain",
                                alt: "Organization Logo",
                                src: match$2
                              }) : (
                            match$3 !== undefined ? JsxRuntime.jsx("img", {
                                    className: "w-full h-full object-contain",
                                    alt: "Organization Logo",
                                    src: match$3
                                  }) : JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: "🏢",
                                            className: "text-4xl"
                                          }),
                                      JsxRuntime.jsx("p", {
                                            children: "No logo",
                                            className: "text-xs mt-2"
                                          })
                                    ],
                                    className: "text-center text-gray-400"
                                  })
                          ),
                        className: "w-32 h-32 rounded-lg border-2 border-gray-200 bg-gray-50 flex items-center justify-center overflow-hidden"
                      }),
                  className: "flex-shrink-0"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("button", {
                                  children: "Change Logo",
                                  className: "px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl transition-colors",
                                  onClick: showUploadInputField
                                }),
                            state.logo_edited ? JsxRuntime.jsx("button", {
                                    children: "Revert Changes",
                                    className: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors",
                                    onClick: revertLogoChanges
                                  }) : null
                          ],
                          className: "flex flex-wrap items-center gap-2 sm:gap-3"
                        }),
                    JsxRuntime.jsx("p", {
                          children: "Recommended size: 200x200px. Formats: PNG, JPG, JPEG. Max size: 300KB",
                          className: "text-xs text-gray-500 mt-3"
                        })
                  ],
                  className: "flex-1 min-w-0"
                })
          ],
          className: "flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                alertType !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                              alertType: alertType,
                              handleClose: (function (param) {
                                  Curry._1(setState, (function (state) {
                                          return {
                                                  logo_edited: state.logo_edited,
                                                  name_edited: state.name_edited,
                                                  saving: state.saving,
                                                  showUploadInputField: state.showUploadInputField,
                                                  logoUrl: state.logoUrl,
                                                  logoFile: state.logoFile,
                                                  notification: undefined,
                                                  logoError: state.logoError
                                                };
                                        }));
                                })
                            }),
                        className: "max-w-7xl mx-auto px-6 sm:px-8 py-4"
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("span", {
                                                                children: "🏢",
                                                                className: "text-xl"
                                                              }),
                                                          className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm flex-shrink-0"
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("h1", {
                                                                  children: "Organization Profile",
                                                                  className: "text-xl sm:text-2xl font-bold text-gray-900"
                                                                }),
                                                            JsxRuntime.jsx("p", {
                                                                  children: "Manage your organization's basic information and settings",
                                                                  className: "text-sm text-gray-600 mt-1"
                                                                })
                                                          ],
                                                          className: "min-w-0"
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-3 min-w-0"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    hasChanges ? JsxRuntime.jsx("span", {
                                                            children: "Unsaved changes",
                                                            className: "px-3 py-1.5 text-xs font-medium text-orange-700 bg-orange-50 rounded-full border border-orange-200"
                                                          }) : null,
                                                    JsxRuntime.jsx("button", {
                                                          children: state.saving ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                                  children: [
                                                                    JsxRuntime.jsx("span", {
                                                                          className: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
                                                                        }),
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "Saving..."
                                                                        })
                                                                  ]
                                                                }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                                  children: [
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "💾"
                                                                        }),
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "Save Changes"
                                                                        })
                                                                  ]
                                                                }),
                                                          className: (
                                                            !enableUpdate && !state.saving ? "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-lg hover:shadow-xl" : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                          ) + " px-5 py-2.5 rounded-lg font-medium text-sm transition-all duration-200 disabled:cursor-not-allowed flex items-center space-x-2",
                                                          disabled: enableUpdate || state.saving,
                                                          onClick: saveClientDetails
                                                        })
                                                  ],
                                                  className: "flex flex-wrap items-center gap-2 sm:gap-3 sm:flex-shrink-0"
                                                })
                                          ],
                                          className: "flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between"
                                        }),
                                    className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-4 sm:px-6 py-5 sm:py-6 border-b border-gray-200"
                                  }),
                              className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("span", {
                                                              children: "📝",
                                                              className: "text-lg"
                                                            }),
                                                        JsxRuntime.jsx("h2", {
                                                              children: "Organization Details",
                                                              className: "text-lg font-bold text-gray-900"
                                                            })
                                                      ],
                                                      className: "flex items-center space-x-2"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "Basic information about your organization",
                                                      className: "text-sm text-gray-600 mt-1"
                                                    })
                                              ],
                                              className: "bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsxs("label", {
                                                            children: [
                                                              "Organization Name",
                                                              JsxRuntime.jsx("span", {
                                                                    children: "*",
                                                                    className: "text-red-500 ml-1"
                                                                  })
                                                            ],
                                                            className: "block text-sm font-medium text-gray-700 mb-2"
                                                          }),
                                                      JsxRuntime.jsx("input", {
                                                            className: "w-full min-w-0 max-w-full box-border px-4 py-3 border rounded-lg text-sm transition-all duration-200 overflow-hidden text-ellipsis whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent " + (
                                                              Organization$ReactHooksTemplate.name(organizationProfile) === "" ? "border-red-300 bg-red-50" : "border-gray-300 bg-white hover:border-gray-400"
                                                            ),
                                                            title: Organization$ReactHooksTemplate.name(organizationProfile),
                                                            placeholder: "Enter your organization name",
                                                            type: "text",
                                                            value: Organization$ReactHooksTemplate.name(organizationProfile),
                                                            onChange: (function (param) {
                                                                var name = param.target.value;
                                                                Curry._1(setOrganizationProfile, Organization$ReactHooksTemplate.setName(organizationProfile, name));
                                                                return Curry._1(setState, (function (state) {
                                                                              return {
                                                                                      logo_edited: state.logo_edited,
                                                                                      name_edited: true,
                                                                                      saving: state.saving,
                                                                                      showUploadInputField: state.showUploadInputField,
                                                                                      logoUrl: state.logoUrl,
                                                                                      logoFile: state.logoFile,
                                                                                      notification: state.notification,
                                                                                      logoError: state.logoError
                                                                                    };
                                                                            }));
                                                              })
                                                          }),
                                                      Organization$ReactHooksTemplate.name(organizationProfile) === "" ? JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("span", {
                                                                      children: "⚠️"
                                                                    }),
                                                                JsxRuntime.jsx("span", {
                                                                      children: "Organization name is required"
                                                                    })
                                                              ],
                                                              className: "mt-2 flex items-center space-x-1 text-red-600 text-xs"
                                                            }) : null
                                                    ],
                                                    className: "max-w-2xl w-full min-w-0"
                                                  }),
                                              className: "p-4 sm:p-6"
                                            })
                                      ],
                                      className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("span", {
                                                              children: "🎨",
                                                              className: "text-lg"
                                                            }),
                                                        JsxRuntime.jsx("h2", {
                                                              children: "Organization Logo",
                                                              className: "text-lg font-bold text-gray-900"
                                                            })
                                                      ],
                                                      className: "flex items-center space-x-2"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "Upload your organization's logo (PNG, JPG, JPEG - Max 300KB)",
                                                      className: "text-sm text-gray-600 mt-1"
                                                    })
                                              ],
                                              className: "bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx("div", {
                                                    children: tmp,
                                                    className: "max-w-2xl"
                                                  }),
                                              className: "p-6"
                                            })
                                      ],
                                      className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("span", {
                                                              children: "🌍",
                                                              className: "text-lg"
                                                            }),
                                                        JsxRuntime.jsx("h2", {
                                                              children: "Time Zone",
                                                              className: "text-lg font-bold text-gray-900"
                                                            })
                                                      ],
                                                      className: "flex items-center space-x-2"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "Set your organization's default time zone",
                                                      className: "text-sm text-gray-600 mt-1"
                                                    })
                                              ],
                                              className: "bg-gradient-to-r from-green-50 to-emerald-50 px-6 py-4 border-b border-gray-200"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("label", {
                                                            children: "Default Time Zone",
                                                            className: "block text-sm font-medium text-gray-700 mb-2"
                                                          }),
                                                      JsxRuntime.jsx("select", {
                                                            children: $$Array.of_list(Belt_List.map(TimeZones$ReactHooksTemplate.allTimeZones, (function (option) {
                                                                        return JsxRuntime.jsx("option", {
                                                                                    children: TimeZones$ReactHooksTemplate.label(option),
                                                                                    value: TimeZones$ReactHooksTemplate.value(option)
                                                                                  }, TimeZones$ReactHooksTemplate.value(option));
                                                                      }))),
                                                            className: "w-full px-4 py-3 border border-gray-300 rounded-lg text-sm bg-white\n                        hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500\n                        focus:border-transparent transition-all duration-200",
                                                            value: Organization$ReactHooksTemplate.timeZone(organizationProfile),
                                                            onChange: handleChange
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: "This time zone will be used for all date and time displays in your organization",
                                                            className: "text-xs text-gray-500 mt-2"
                                                          })
                                                    ],
                                                    className: "max-w-2xl"
                                                  }),
                                              className: "p-6"
                                            })
                                      ],
                                      className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
                                    })
                              ],
                              className: "space-y-6"
                            })
                      ],
                      className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 min-w-0"
                    })
              ],
              className: "h-full bg-gray-50"
            });
}

var make = OrganisationProfile;

exports.make = make;
/* react Not a pure module */
